<template>
	<div>
		<draggable class="drag-container" animation="300" v-bind="draggableOptions" v-model="paper.questionsList" @sort="changeSort" :move="checkMove">
			<transition-group tag="div" type="transition" :name="'flip-list'">
				<div
					:name="`name${item.qid}`"
					:gutter="10"
					:id="index"
					class="item_container"
					:class="{ item_container_hover: item.isedit }"
					v-for="(item, index) in paper.questionsList"
					:key="item.qid"
					:ref="item.qid"
				>
					<div class="border-none">
						<!-- 手机号 单行、多行输入框 填空题 -->
						<QuestionBlank
							:ref="`ques${item.qid}`"
							v-if="item.questionsTypeId == 2 || item.questionsTypeId == 3 || item.questionsTypeId == 4 || item.questionsTypeId == 5"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							@setEditIndex="setEditIndex(index)"
						/>

						<!-- 单项选择题 -->
						<QuestionSingle2
							v-else-if="item.questionsTypeId == 8"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							:editIndex="editIndex"
							:questionList="paper.questionsList"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
							@wjsetquestionoption="wjsetquestionoption"
						/>

						<!-- 多项选择 -->
						<QuestionMult2
							v-else-if="item.questionsTypeId == 10"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							:editIndex="editIndex"
							:questionList="paper.questionsList"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
							@wjsetquestionoption="wjsetquestionoption"
						/>

						<!-- 判断题 -->
						<QuestionJudge
							v-else-if="item.questionsTypeId == 12"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							:editIndex="editIndex"
							@wjaddquestionoption="wjaddquestionoption"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
						/>

						<!-- 下拉框 -->
						<QuestionDropDownBox
							v-model="value1"
							v-else-if="item.questionsTypeId == 9"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							:editIndex="editIndex"
							:editOptionIndex="editOptionIndex"
							:questionList="paper.questionsList"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@questiondel="questiondel"
							@jumpshow="jumpshow"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
							@questionCopy="questionCopy"
						/>

						<!-- 多项填空 -->
						<QuestionMu
							v-model="value1"
							v-else-if="item.questionsTypeId == 35"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							:editIndex="editIndex"
							:editOptionIndex="editOptionIndex"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@wjsetquestionoption="wjsetquestionoption"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
						/>
						<!-- 图片选择 -->
						<QuestionImage
							v-model="value1"
							v-else-if="item.questionsTypeId == 6"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							:editIndex="editIndex"
							:editOptionIndex="editOptionIndex"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
						/>
						<!-- 星级评分 -->
						<QuestionRate
							ref="setImg"
							v-else-if="item.questionsTypeId == 11"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							:editIndex="editIndex"
							:editOptionIndex="editOptionIndex"
							:imageUrl="imageUrl"
							:tipsObj="tipsObj"
							@setEditIndex="setEditIndex"
						/>
						<!-- 日期选择 -->
						<QuestionDate
							v-model="value1"
							v-else-if="item.questionsTypeId == 13"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							:editIndex="editIndex"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
						/>
						<!-- 排序题 -->
						<QuestionSort
							v-model="value1"
							v-else-if="item.questionsTypeId == 14"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							:editIndex="editIndex"
							:editOptionIndex="editOptionIndex"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
						/>
						<!-- 地址位置 -->
						<QuestionAddress
							v-model="value1"
							v-else-if="item.questionsTypeId == 15"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							:editIndex="editIndex"
							:editOptionIndex="editOptionIndex"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
						/>

						<!-- 城市选择 -->
						<QuestionCity
							v-model="value1"
							v-else-if="item.questionsTypeId == 16"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							:editIndex="editIndex"
							:editOptionIndex="editOptionIndex"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
						/>

						<!-- 矩阵单选 -->
						<QuestionRectSingle
							v-else-if="item.questionsTypeId == 19"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							@deleteOptionColumn="deleteOptionColumn"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@wjsetquestionoption="wjsetquestionoption"
							@questiondel="questiondel"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
							@addRows="addRows"
							@addColumn="addColumn"
							@batchAddRows="batchAddRows"
							@batchAddColumns="batchAddColumns"
						/>
						<!-- 矩阵多选 -->
						<QuestionRectMult
							v-else-if="item.questionsTypeId == 20"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							@deleteOptionColumn="deleteOptionColumn"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@wjsetquestionoption="wjsetquestionoption"
							@questiondel="questiondel"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
							@addRows="addRows"
							@addColumn="addColumn"
							@batchAddRows="batchAddRows"
							@batchAddColumns="batchAddColumns"
						/>
						<!-- 矩阵星级评分 -->
						<QuestionMatrixRate
							v-else-if="item.questionsTypeId == 21"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							@deleteOptionColumn="deleteOptionColumn"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@wjsetquestionoption="wjsetquestionoption"
							@questiondel="questiondel"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
							@addRows="addRows"
							@addColumn="addColumn"
							@batchAddRows="batchAddRows"
							@batchAddColumns="batchAddColumns"
						/>
						<!-- 矩阵填空 -->
						<QuestionMatrixBlank
							v-else-if="item.questionsTypeId == 22"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							@deleteOptionColumn="deleteOptionColumn"
							@wjaddquestionoption="wjaddquestionoption"
							@wjdelquestionoption="wjdelquestionoption"
							@wjsetquestionoption="wjsetquestionoption"
							@questiondel="questiondel"
							@setEditIndex="setEditIndex"
							@setEditOptionIndex="setEditOptionIndex"
							@addRows="addRows"
							@addColumn="addColumn"
							@batchAddRows="batchAddRows"
							@batchAddColumns="batchAddColumns"
						/>
						<!-- 段落标题 -->
						<QuestionParagraph 
							v-else-if="item.questionsTypeId == 25" 
							:index="index" 
							:question="item" 
							@questiondel="questiondel"
							@setEditIndex="setEditIndex"
						/>
						<!-- 分页 -->
						<QuestionPaging
							v-else-if="item.questionsTypeId == 26"
							:index="index"
							:question="item"
							@questiondel="questiondel"
							@setEditIndex="setEditIndex"
						/>
						<!-- 上传文件 -->
						<QuestionUploadFile
							v-else-if="item.questionsTypeId == 33"
							:isBankViewTest="isBankViewTest"
							:index="index"
							:question="item"
							@setEditIndex="setEditIndex"
						/>
					</div>
					<!-- 时间选择 -->
					<QuestionTime
						v-model="value1"
						v-if="item.questionsTypeId == 17"
						:isBankViewTest="isBankViewTest"
						:index="index"
						:question="item"
						@setEditIndex="setEditIndex"
					/>
					<!-- 横向填空 -->
					<QuestionCrosswiseBlank
						v-else-if="item.questionsTypeId == 34"
						:isBankViewTest="isBankViewTest"
						:index="index"
						:question="item"
						@setEditIndex="setEditIndex"
					/>

					<QuestionCascadeCascading
						v-else-if="item.questionsTypeId == 36"
						:isBankViewTest="isBankViewTest"
						:index="index"
						:question="item"
						@setEditIndex="setEditIndex"
					/>
					<QuestionProportion
						v-else-if="item.questionsTypeId == 37"
						v-model="value1"
						:isBankViewTest="isBankViewTest"
						:index="index"
						:question="item"
						@wjdelquestionoption="wjdelquestionoption"
						@wjaddquestionoption="wjaddquestionoption"
						@setEditIndex="setEditIndex"
					/>
					
					
					<!-- 量表 -->
					<QuestionScale
						ref="setImg"
						v-else-if="item.questionsTypeId == 38"
						:isBankViewTest="isBankViewTest"
						:index="index"
						:question="item"
						:editIndex="editIndex"
						:editOptionIndex="editOptionIndex"
						:imageUrl="imageUrl"
						:tipsObj="tipsObj"
						@setEditIndex="setEditIndex"
					/>
					<!-- 多维表格 --> 
				
					<QuestionMultidimensionalTable
						v-else-if="item.questionsTypeId == 39"
						:isBankViewTest="isBankViewTest"
						:index="index"
						:question="item"
						@deleteOptionColumn="deleteOptionColumn"
						@wjaddquestionoption="wjaddquestionoption"
						@wjdelquestionoption="wjdelquestionoption"
						@wjsetquestionoption="wjsetquestionoption"
						@questiondel="questiondel"
						@setEditIndex="setEditIndex"
						@setEditOptionIndex="setEditOptionIndex"
						@addRows="addRows"
						@addColumn="addColumn"
						@batchAddRows="batchAddRows"
						@batchAddColumns="batchAddColumns"
					/>
				</div>
			</transition-group>
		</draggable>
	</div>
</template>
<script>
import draggable from 'vuedraggable';
import QuestionBlank from './QuestionBlank';
import QuestionSingle2 from './QuestionSingle2';
import QuestionMult2 from './QuestionMult2';
import QuestionJudge from './QuestionJudge';
import QuestionMu from './QuestionMu';
import QuestionDropDownBox from './QuestionDropDownBox';
import QuestionImage from './QuestionImage';
import QuestionRate from './QuestionRate';
import QuestionScale from './QuestionScale';

import QuestionDate from './QuestionDate';
import QuestionSort from './QuestionSort';
import QuestionAddress from './QuestionAddress';
import QuestionCity from './QuestionCity';
import QuestionRectSingle from './QuestionRectSingle';
import QuestionRectMult from './QuestionRectMult';
import QuestionMatrixRate from './QuestionMatrixRate';
import QuestionMatrixBlank from './QuestionMatrixBlank';
import QuestionParagraph from './QuestionParagraph';
import QuestionPaging from './QuestionPaging';
import QuestionUploadFile from './QuestionUploadFile';
import QuestionTime from './QuestionTime';
import QuestionCrosswiseBlank from './QuestionCrosswiseBlank';
import QuestionCascadeCascading from './QuestionCascadeCascading';
import QuestionProportion from './QuestionProportion';
import QuestionMultidimensionalTable from './QuestionMultidimensionalTable';
import Paper from '../../js/Paper';
import { logicalSettings } from '../../js/logicalSettings';
// import TitleEditor from "@/components/titleEditor/titleEditor.vue"
import { v1 as UUID } from 'uuid';
// import questionGap from "./questionGap.vue"
// import questionMore from "./questionMore.vue"
// import questionSingle from "./questionSingle.vue"
import { mapState } from 'vuex';
// import Paper from "@/components/examQuesTemplate/js/Paper.js"

import CheckType from '@/util/JSON/checkType.json';
export default {
	name: 'questionnaireQuesTemplate',
	components: {
		draggable,
		QuestionBlank,
		QuestionSingle2,
		QuestionMult2,
		QuestionJudge,
		QuestionDropDownBox,
		QuestionMu,
		QuestionImage,
		QuestionRate,
		QuestionScale,
		QuestionDate,
		QuestionSort,
		QuestionAddress,
		QuestionCity,
		QuestionRectSingle,
		QuestionRectMult,
		QuestionMatrixRate,
		QuestionMatrixBlank,
		QuestionParagraph,
		QuestionPaging,
		QuestionUploadFile,
		QuestionTime,
		QuestionCrosswiseBlank,
		QuestionCascadeCascading, //级联题
		QuestionProportion, // 比重题
		QuestionMultidimensionalTable,//多维表格
		// TitleEditor,
		// questionSingle,
		// questionGap,
		// questionMore,
	},
	props: {
		tipsObj: { type: Object },
		imageUrl: { type: Object },
		editOptionIndex: { type: String, default: '0_0' },
		paper: {
			type: Object,
			default: () => {}
		},
		editIndex: { type: Number, default: 0 },
		// 管理题库时查看试题 只可以删除 其余不能操作试题
		isBankViewTest: {
			type: Boolean,
			default: false
		}
	},
	provide() {
		return {
			toDelFormBank: this.delFormBank,
			toGetBankList: this.getBankList,
			IsGetBankList:()=>this.bankList,
			addBank: this.addBank,
			addToBank: this.addToBank
		};
	},
	data() {
		return {
			// draggableOptions: {
			// 	handle: '.handle'
			// },
			inputHeightList: [this.$t('main.small'), this.$t('main.middle'), this.$t('main.big')],
			bankList: [],
			value1: '',
			draggableOptions: {
				handle: '.drag-handle'
			},
		};
	},
	provide() {
		return {
			isBankViewTest: () => this.isBankViewTest,
			getBankList: this.getBankList,
			BankList: () => this.bankList,
			addToBank: this.addToBank,
			addBank: this.addBank,
			delFormBank: this.delFormBank
		};
	},
	computed: {
		...mapState(['wjQuestionTypeArr', 'examQuestionTypeArr']),
		//选项验证类型
		formatList () {
			return CheckType
		}
	},
    created() {
        this.getBankList()
    },
    methods: {
		questionCopy(question){
			this.$emit('wjQuestionCopy',question)
		},
		checkMove(evt) {
			console.log('evt.draggedContext.element :>> ', evt.draggedContext.element, evt.relatedContext.element.questionsTypeId);
			if (evt.relatedContext.element.questionsTypeId == '26' && evt.relatedContext.element.pageNumber == 1) {
				return false
			}
			return true
		},
        // 题目重新排序
        changeSort() {
			// console.log(this.paper.questionsList)
			let pageNumber = 1
			let quesIndex = 0
			this.paper.questionsList.forEach((info, index) =>{
				// console.log(info.questionsTypeId)
				if(info.questionsTypeId == '26') {
					info.pageNumber = pageNumber++
				} else if (this.wjQuestionTypeArr.indexOf(info.questionsTypeId) != -1) {       
					info.quesIndex = quesIndex++
				}
			})
        },
        addBank(e,qid) {
            let that = this
            let params = {
                that: this,
                url: `${this.$config.service.examBankSave}`,
                method: "POST",
                data: e,
                cb(res) {
                    // console.log(res)
                    if (res.code == '0'){
                        let paper = new Paper();
                        that.setPaperJson(res.message, paper, qid)
                    } else {
                        that.$message.error(res.message)
                    }
                },
            };
            this.$util.request(params);
        },
        
        setPaperJson(id, paper, qid) {
            let that = this;
            let data = {
                id: id,
                paperjson: JSON.stringify(paper),
                bankType: 1
            }
            let params = {
                that: this,
                url: `${this.$config.service.examBankAddQuess}`,
                method: "post",
                data: data,
                cb(res) {
                    if (res.code == '0') {
                        that.getBankList()
                    } else {
                        that.$message.error(res.message)
                    }
                },
            };
            this.$util.request(params);
        },
        delFormBank(e) {
            console.log(e)
            let ids = [e.bqid]
            let that = this;
            let params = {
                that: this,
                url: `${this.$config.service.examBankRecycleBinCancel}?ids=${ids}`,
                method: "GET",
                cb(res) {
                    if (res.code == '0') {
                        that.$message({
                            message: that.$t('main.CancelFavorite'),
                            type: 'success'
                        });
                        e.bqid = ''
                        that.$emit('toGetQuestion')
						that.$emit('submit')
                    } else {
                        that.$message.error(that.$t('main.CancelFailed'))
                    }
                },
            };
            this.$util.request(params);
        },
        addToBank(e,id) {
            // 未改
            // this.$set(e, 'qid', UUID())
			let question = logicalSettings(JSON.parse(JSON.stringify(e)))
			let tageName = ''
			if(e.quesLabelName){
				tageName = e.quesLabelName.toString()
			}else{
				tageName = ''
			}
            this.$set(e, 'bid', id)
            let that = this;
            let data = {
                quesName: question.questionsName,
                bid: id,
                quesJson: JSON.stringify(question),
				tageName: tageName
            }
            let params = {
                that: this,
                url: `${this.$config.service.examBankUpdateQues}`,
                method: "post",
                data: data,
                cb(res) {
                    if (res.code == '0') {
                        that.$set(e, 'bqid', res.message)
						that.$emit('submit')
                        that.$message({
                            message: that.$t('main.CollectionSuccessful'),
                            type: 'success'
                        });
						console.log(res.message)
						console.log(e.bqid)
                    } else {
                        e.bqid = ''
                        e.bid = ''
                        that.$message.error(res.message)
                    }
                },
            };
            this.$util.request(params);
        },
        getBankList() {
            let that = this
            let data = this.$qs.stringify({
                'isSystem': 0, // 0自建题库 1系统题库
                'pageIndex': 1,
                'pageSize': 10000,
                'bankType': 1
            })
            let params = {
                that: this,
                url: `${this.$config.service.examBankList}?${data}`,
                method: "GET",
                cb(res) {
                    // console.log(res)
                    if (res.code == '0'){
                        that.bankList = res.resultBody.datas
                    } else {
						that.bankList = []
					}
                },
            };
            this.$util.request(params);
        },
        // 删除题 删除行
        questiondel(qid, SonId, associated) {
            this.$emit('questiondel', qid, SonId, associated)
        },
        // 逻辑设置弹窗
        jumpshow(question) {
            this.$emit('jumpshow', question)
        },
        setEditIndex(index) {
            this.$emit('setEditIndex', index)
        },
        setEditOptionIndex(childIndex) {
            this.$emit('setEditOptionIndex', childIndex)
        },
        wjaddquestionoption(qid, Arr, qType, haveInput){
            this.$emit('wjaddquestionoption', qid, Arr, qType, haveInput)
        },
        wjdelquestionoption(obj, index) {
            this.$emit('wjdelquestionoption', obj, index)
        },
        wjsetquestionoption(question, option, index, type) {
            this.$emit('wjsetquestionoption', question, option, index, type)
        },
        addRows(text) {
            this.$emit('addRows', text)
        },
        addColumn(text) {
            this.$emit('addColumn', text)
        },
        batchAddRows(arr) {
            this.$emit('batchAddRows', arr)
        },
        batchAddColumns(arr) {
            this.$emit('batchAddColumns', arr)
        },
        
        deleteOptionColumn(obj) {
            this.$emit('deleteOptionColumn', obj)
        },
        // submit(state) {
        //     this.$emit('submit', state)
        // }

    }
}
</script>

<style scoped lang="scss">
.box-all-active {
	border: 1px solid #409eff;
}

.box-all {
	line-height: 30px;
	margin-bottom: 5px;
	background-color: #fff;
	padding: 10px;
	box-sizing: border-box;
	border-radius: 4px;
	outline: none;
	box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.1);
}
.content-box {
	background-color: rgb(255, 255, 255);
}
.content {
	padding: 0 10px;
}
.box {
	display: flex;
	justify-content: space-between;
}
.box-f {
	width: 80%;
	font-size: 16px;
	font-weight: bold;
	display: flex;
}
.box-f span {
	padding-right: 15px;
}
.box-icon i {
	padding-left: 20px;
}
.box-c,
.box-d {
	padding-left: 22px;
}
.el-container {
	font-size: 14px;
}
.title {
	margin: 10px 0;
}

.tip {
	color: #999;
	font-size: 14px;
	padding-left: 10px;
}
.el-main {
	background-color: #eee;
}
.submit-exam {
	width: 100%;
	margin-top: 20px;
}
.edid-box {
	margin-top: 10px;
	border-top: 1px solid #999;
	font-size: 14px;
	/* height: 400px; */
	padding-bottom: 20px;
}
.title-h4 {
	padding-left: 30px;
}

.subject-box {
	width: 380px;
	line-height: 60px;
	margin: 0 auto;
}
.subject {
	display: flex;
	justify-content: space-between;
	border-bottom: 1px solid #999;
	align-items: center;
}
.placeholder-input {
	width: 64%;
}
.exam-title {
	display: inline-block;
}
.exam-title,
.outline-none {
	outline: none;
	max-width: 73%;
	margin-top: 5px;
}
</style>
<style lang="scss">
.dropdown-item {
	display: flex;
	justify-content: space-between;
	align-items: center;
	.btn {
		margin-left: 10px;
	}
}
.to-bank {
	color: #424542;
}
.my-bank-tag {
	display: inline-block;
	box-sizing: border-box;
	padding: 1px 6px;
	background: rgba(38, 114, 255, 0.08);
	color: rgba(38, 114, 255, 0.7);
	font-size: 12px;
	line-height: 1.5;
}
.setBtn-box {
	display: flex;
	align-items: center;
	justify-content: flex-end;
}
</style>
